// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UBzt","badges":"styles_badges__3qoVl"};